export default __webpack_public_path__ + "static/media/solas-learning-works.9dd75af9.png";